<template>
  <base-modal
    :controlled="true"
    :open="isOpen"
    :unmountAfterMs="1000"
    :closeable="false"
    class="m-h-0"
  >
    <div class="user-onboarding-rating">
      <div class="header mb-8 flex justify-center">
        <h5>{{ $t('home.userOnboarding.rating.title') }}</h5>
      </div>

      <div class="footer flex justify-center">
        <Button
          type="filled"
          color="primary"
          class="mr-2 w-full"
          @click="onYes(userOnboardingPerPageName === 'dashboard' ? 'obd2_like_time' : 'obd1_like_time')"
        >
          {{ $t('home.userOnboarding.rating.btnYes') }}
        </Button>

        <Button
          type="flat"
          color="primary"
          class="mr-2 w-full"
          @click="onNo(userOnboardingPerPageName === 'dashboard' ? 'obd2_dislike_time' : 'obd1_dislike_time')"
        >
          {{ $t('home.userOnboarding.rating.btnNo') }}
        </Button>
      </div>
    </div>
  </base-modal>
</template>

<script>
import Button from "../Button/Button.vue";
import userAgent from "../../core/helpers/userAgent";
import userOnboardingPerPage from "../../core/services/userOnboardingPerPage";
import BaseModal from "../Modal/BaseModal.vue";
import { mapState } from 'vuex';
import onboardingService from '../../core/services/onboardingService';

export default {
  name: "UserOnboardingRating",
  components: { Button, BaseModal },
  data() {
    return {     
      isOpen: true,

      typeAction: {
        yes: {
          campaign: 'obd1_like_time',
          dashboard: 'obd2_like_time'
        },
        no: {
          campaign: 'obd1_dislike_time',
          dashboard: 'obd2_dislike_time'
        }
      }
    };
  },

  computed: {
    ...mapState({
      userOnboardingPerPageName: (state) =>
        state.vueOnboarding.onboardingPerPage.pageName,
    })
  },

  created() {   
  },
  watch: {   
  },
  methods: {
    onYes(typeAction) {     
      onboardingService.setFinish(false);     

      let pageName = this.userOnboardingPerPageName;      

      let params = {
        page_name: pageName,
        type_action: typeAction,
      };      

      userOnboardingPerPage.syncUserOnboardingToAirTable(params);      
    },

    onNo(typeAction) {      
      onboardingService.setFinish(false);
      let pageName = this.userOnboardingPerPageName;     

      let params = {
        page_name: pageName,
        type_action: typeAction,
      };

      userOnboardingPerPage.syncUserOnboardingToAirTable(params);
    },   
  },
};
</script>

<style lang="scss">
.base-modal__main {
  min-height: 0 !important;
}

</style>


// WEBPACK FOOTER //
// src/components/UserOnboardingVersion2/UserOnboardingRating.vue